import React from 'react'
import { Image, OverlayTrigger } from 'react-bootstrap'

/**
 * Displays a passed image as small thumbnail. Gets displayed in a big overlay when triggered (by either click or hover)
 * @param {any} imageProp the image to be displayed
 */
const RenderImage = ( imageProp ) => {
    const renderFullImage = (imageProp) => {
        return (
            <Image className="fullimage" src={imageProp} />
        )
    }

    return (
        <OverlayTrigger overlay={renderFullImage(imageProp)} placement="right">
            <Image className="thumbnail" src={imageProp} thumbnail />
        </OverlayTrigger>
    )
}

export { RenderImage }